import { ChevronRight } from "lucide-react";
import { InfiniteListBase, useListContext, useTranslate } from "ra-core";
import { Link } from "react-router";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { InfinitePagination } from "../misc/InfinitePagination";
import type { Partner } from "../types";
import { PartnerKind } from "./PartnerKind";

/** Mobile list of staff and partners. */
export const PartnerListMobile = () => (
  <InfiniteListBase perPage={25} sort={{ field: "name", order: "ASC" }}>
    <PartnerListLayoutMobile />
  </InfiniteListBase>
);

const PartnerListLayoutMobile = () => {
  const translate = useTranslate();
  const { data, error } = useListContext<Partner>();

  return (
    <>
      <MobileHeader showRefresh>
        <h1 className="text-xl font-semibold">
          {translate("resources.partners.name", { smart_count: 2 })}
        </h1>
      </MobileHeader>
      <MobileContent>
        <ul className="divide-y">
          {data?.map((partner) => (
            <li key={partner.id}>
              <Link
                to={`/partners/${partner.id}/show`}
                className="flex items-center gap-3 py-3"
              >
                <div className="flex-1 min-w-0">
                  <div className="font-medium truncate">{partner.name}</div>
                  <div className="text-sm text-muted-foreground">
                    <PartnerKind partner={partner} />
                  </div>
                </div>
                <ChevronRight className="size-4 text-muted-foreground" />
              </Link>
            </li>
          ))}
        </ul>
        {!error && (
          <div className="flex justify-center">
            <InfinitePagination />
          </div>
        )}
      </MobileContent>
    </>
  );
};
